import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { isMobileUA } from 'dpl/shared/utils';
import SmartImage from 'dpl/components/SmartImage';

import { ARTICLE_CONTENT_COL_CLASSES } from '../utils/constants';

const AUTHOR_IMAGE_DIAMETER = isMobileUA() ? '64px' : '132px';

export default function FeaturedAuthor({ sliceData }) {
  const authors = sliceData.items.map(i => i.author.data).filter(Boolean);

  return (
    <div className="PrismicFeaturedAuthor container">
      <div className="row">
        <div className={ARTICLE_CONTENT_COL_CLASSES}>
          <div className="pv8 pv14-lg bt bb bw2">
            {authors.map((author, idx) => (
              <div
                key={idx}
                className={classnames('flex center', { pt14: idx !== 0 })}
              >
                {author.avatar.url && (
                  <SmartImage
                    key={idx}
                    Tag="div"
                    src={author.avatar.url}
                    width={AUTHOR_IMAGE_DIAMETER}
                    height={AUTHOR_IMAGE_DIAMETER}
                    className="bg-center cover br-100 mr2"
                    lazy
                  />
                )}
                <div className="pl7 self-center">
                  {author.full_name && <span>{author.full_name}</span>}
                  {author.bio && <span>&nbsp;{author.bio}</span>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

FeaturedAuthor.propTypes = {
  sliceData: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        author: PropTypes.shape({
          data: PropTypes.shape({
            full_name: PropTypes.string,
            avatar: PropTypes.shape({
              url: PropTypes.string
            }),
            bio: PropTypes.string
          })
        })
      })
    )
  }).isRequired
};
